import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
    headingStyle: {
        fontFamily: "MANEurope, Arial, sans-serif",
        fontSize: theme.typography.pxToRem(40),
        fontWeight: "bold",
        color: "#303a44",
        lineHeight: 1.13,
        textTransform: "uppercase",
    },
});

const Heading2 = ({ classes: { headingStyle }, className, component, children, ...otherProps }) => {
    const headingClass = classNames(headingStyle, className);
    return (
        <Typography component={component || "h2"} className={headingClass} {...otherProps}>
            {children}
        </Typography>
    );
};

Heading2.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    children: PropTypes.node,
};

export default withStyles(styles)(Heading2);



// WEBPACK FOOTER //
// ./src/styleguide/Heading2.js